import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";

export default function Footer({ lang }) {
  const { t } = useTranslation();
  const prefix = lang === "es" ? "/es" : "";

  const links = [
    { to: `${prefix}/services`, label: t("nav.services") },
    { to: `${prefix}/about`, label: t("nav.about") },
    { to: `${prefix}/portfolio`, label: t("nav.portfolio") },
    { to: `${prefix}/testimonials`, label: t("nav.testimonials") },
    { to: `${prefix}/contact`, label: t("nav.contact") },
    { to: `${prefix}/estimate`, label: t("nav.estimate") },
  ];

  return (
    <footer data-testid="site-footer" className="bg-navy text-offwhite">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/assets/logo-light.png" alt="VIALFA Handyman Services" className="h-20 w-auto mb-6" data-testid="footer-logo" />
          <p className="text-offwhite/60 leading-relaxed max-w-sm">{t("footer.tagline")}</p>
          <p className="mt-4 text-offwhite/40 text-xs tracking-widest uppercase">VIALFA Construction &amp; Development Group · VIALFA Handyman Services</p>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-offwhite/40 mb-5">{t("footer.explore")}</h4>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-offwhite/70 hover:text-orange transition-colors duration-200">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-offwhite/40 mb-5">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-sm text-offwhite/70">
            <li><a href="tel:17867746692" data-testid="footer-phone" className="flex items-center gap-2 hover:text-orange transition-colors duration-200"><Phone size={14} /> 786-774-6692</a></li>
            <li><a href="mailto:info@vialfa.com" data-testid="footer-email" className="flex items-center gap-2 hover:text-orange transition-colors duration-200"><Mail size={14} /> info@vialfa.com</a></li>
            <li><a href="https://instagram.com/vialfaservices" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-2 hover:text-orange transition-colors duration-200"><Instagram size={14} /> @vialfaservices</a></li>
            <li className="flex items-center gap-2"><MapPin size={14} /> Miami, FL 33130</li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-offwhite/40 mb-5">{t("footer.area")}</h4>
          <p className="text-sm text-offwhite/60 leading-relaxed">{t("footer.areaText")}</p>
        </div>
      </div>
      <div className="border-t border-offwhite/10">
        <div className="px-6 md:px-12 max-w-[1400px] mx-auto py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-offwhite/40">
          <span>© {new Date().getFullYear()} VIALFA. {t("footer.rights")}</span>
          <span>Miami, FL 33130</span>
        </div>
      </div>
    </footer>
  );
}
